/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1BacklistseasonperiodsQueryResponse } from '../../types/GetV1Backlistseasonperiods.ts'

export const getV1BacklistseasonperiodsQueryKey = () =>
    [{ url: '/v1/BacklistSeasonPeriods' }] as const

export type GetV1BacklistseasonperiodsQueryKey = ReturnType<
    typeof getV1BacklistseasonperiodsQueryKey
>

/**
 * {@link /v1/BacklistSeasonPeriods}
 */
export async function getV1Backlistseasonperiods(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<
        GetV1BacklistseasonperiodsQueryResponse,
        ResponseErrorConfig<Error>,
        unknown
    >({ method: 'GET', url: `/v1/BacklistSeasonPeriods`, ...requestConfig })
    return res
}

export function getV1BacklistseasonperiodsQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1BacklistseasonperiodsQueryKey()
    return queryOptions<
        ResponseConfig<GetV1BacklistseasonperiodsQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1BacklistseasonperiodsQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Backlistseasonperiods(config)
        },
    })
}

/**
 * {@link /v1/BacklistSeasonPeriods}
 */
export function useGetV1Backlistseasonperiods<
    TData = ResponseConfig<GetV1BacklistseasonperiodsQueryResponse>,
    TQueryData = ResponseConfig<GetV1BacklistseasonperiodsQueryResponse>,
    TQueryKey extends QueryKey = GetV1BacklistseasonperiodsQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1BacklistseasonperiodsQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1BacklistseasonperiodsQueryKey()

    const query = useQuery(
        {
            ...getV1BacklistseasonperiodsQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
